import React from "react";
import PropTypes from "prop-types";
import {CustomTabPanelInnerContainer} from './Footer.style'
const CustomTabPanelLeft = (props) => {
return (
   <CustomTabPanelInnerContainer>
        {props.children}
   </CustomTabPanelInnerContainer>
  );
};
CustomTabPanelLeft.propTypes = {
    children: PropTypes.any
};
export default CustomTabPanelLeft;
